// GENERATED FILE - do not edit by hand.
// Source: backend ROUTE_MAP. Regenerate with scripts/generate_route_pairs.py
// Maps every URL to its counterpart in the other language, so the header
// language switcher lands on the same page instead of the homepage.

const ROUTE_PAIRS = {
  "/": "/es",
  "/about-us": "/es/acerca-de-nosotros",
  "/about-us/andrew-jee": "/es/acerca-de-nosotros/andrew-jee",
  "/about-us/isabela-a-garcia": "/es/acerca-de-nosotros/isabela-a-garcia",
  "/about-us/our-resources": "/es/acerca-de-nosotros/formularios-y-recursos",
  "/about-us/press": "/es/acerca-de-nosotros/prensa",
  "/about-us/testimonials": "/es/acerca-de-nosotros/testimonios",
  "/blog": "/es/blog",
  "/business-law": "/es/derecho-empresarial",
  "/contact-us": "/es/contactenos",
  "/es": "/",
  "/es/acerca-de-nosotros": "/about-us",
  "/es/acerca-de-nosotros/andrew-jee": "/about-us/andrew-jee",
  "/es/acerca-de-nosotros/formularios-y-recursos": "/about-us/our-resources",
  "/es/acerca-de-nosotros/isabela-a-garcia": "/about-us/isabela-a-garcia",
  "/es/acerca-de-nosotros/prensa": "/about-us/press",
  "/es/acerca-de-nosotros/testimonios": "/about-us/testimonials",
  "/es/blog": "/blog",
  "/es/contactenos": "/contact-us",
  "/es/derecho-de-familia": "/family-law",
  "/es/derecho-de-familia/abuelo-padrastro-adoptivo": "/family-law/grandparents-stepparent-adoptions",
  "/es/derecho-de-familia/activos-inmobiliarios": "/family-law/property-assets",
  "/es/derecho-de-familia/acuerdos-prenupciales-y-postnupciales": "/family-law/prenuptial-postnuptial-agreements",
  "/es/derecho-de-familia/custodia-infantil": "/family-law/child-custody",
  "/es/derecho-de-familia/divorcio": "/family-law/divorce-laws",
  "/es/derecho-de-familia/divorcio-con-altos-activos": "/family-law/high-asset-divorce",
  "/es/derecho-de-familia/divorcio-contencioso": "/family-law/contested-divorce",
  "/es/derecho-de-familia/divorcio-de-parejas-del-mismo-sexo": "/family-law/same-sex-divorce",
  "/es/derecho-de-familia/manutencion-de-los-hijos": "/family-law/child-support",
  "/es/derecho-de-familia/matrimonios-de-hecho": "/family-law/common-law-marriages",
  "/es/derecho-de-familia/ordenes-de-restriccion": "/family-law/restraining-orders",
  "/es/derecho-de-familia/pension-alimenticia": "/family-law/alimony",
  "/es/derecho-de-familia/reproduccion-asistida": "/family-law/assisted-reproduction",
  "/es/derecho-de-familia/separacion-legal": "/family-law/legal-separation",
  "/es/derecho-de-familia/testamentos-y-fideicomisos": "/family-law/wills-and-trusts-dallas-lawyers",
  "/es/derecho-de-familia/violencia-domestica": "/family-law/domestic-violence",
  "/es/derecho-empresarial": "/business-law",
  "/es/post/7-indicadores-de-abuso-emocional": "/post/recognizing-the-signs-understanding-the-7-indicators-of-emotional-abuse",
  "/es/post/abogado-de-divorcios-en-dallas-derecho-familiar": "/post/dallas-divorce-lawyer-child-custody-attorney-in-dallas",
  "/es/post/acuerdos-prenupciales-en-texas-guia-de-un-abogado-de-dallas": "/post/spouse-fails-disclose-assets",
  "/es/post/adopcion-de-padrastro-y-abuelos-en-texas": "/post/stepparent-and-grandparent-adoption-in-texas",
  "/es/post/como-presentar-custodia-hijos-texas": "/post/how-to-file-for-child-custody-in-texas-a-step-by-step-guide",
  "/es/post/diferencia-entre-orden-de-restriccion-y-orden-de-proteccion-en-texas": "/post/understanding-the-difference-between-restraining-orders-and-protective-orders",
  "/es/post/division-bienes-activos-divorcio": "/post/dallas-property-division-community-vs-separate",
  "/es/post/divorcio-entre-personas-del-mismo-sexo-en-texas": "/post/same-sex-divorce-in-texas-lgbtq-family-law-after-obergefell",
  "/es/post/ley-de-trump-manutencion-taxes": "/post/trump-law-child-support-taxes",
  "/es/post/matrimonio-informal-en-texas-cuando-esta-legalmente-casado": "/post/common-law-marriage-in-texas-when-are-you-legally-married",
  "/es/post/nueva-ley-manutencion-hijos-dallas": "/post/trump-child-support-law-what-dallas-parents-should-know",
  "/es/post/planificacion-patrimonial-despues-de-un-divorcio-en-dallas": "/post/estate-planning-after-a-dallas-divorce-wills-and-trusts",
  "/es/post/reproduccion-asistida-y-derecho-familiar-de-texas": "/post/assisted-reproduction-and-texas-family-law-legal-parentage",
  "/es/post/separacion-legal-vs-divorcio-en-texas": "/post/legal-separation-vs-divorce-in-texas-what-your-options-really-are",
  "/es/privacidad": "/privacy",
  "/es/resena": "/review",
  "/es/styleguide": "/styleguide",
  "/es/terminos": "/terms",
  "/es/ubicaciones": "/locations",
  "/es/ubicaciones/arlington": "/locations/arlington",
  "/es/ubicaciones/fort-worth": "/locations/fort-worth",
  "/es/ubicaciones/garland": "/locations/garland",
  "/es/ubicaciones/grand-prairie": "/locations/grand-prairie",
  "/es/ubicaciones/irving": "/locations/irving",
  "/es/ubicaciones/mesquite": "/locations/mesquite",
  "/es/ubicaciones/oak-cliff-bishop-arts": "/locations/oak-cliff-bishop-arts",
  "/es/ubicaciones/plano": "/locations/plano",
  "/family-law": "/es/derecho-de-familia",
  "/family-law/alimony": "/es/derecho-de-familia/pension-alimenticia",
  "/family-law/assisted-reproduction": "/es/derecho-de-familia/reproduccion-asistida",
  "/family-law/child-custody": "/es/derecho-de-familia/custodia-infantil",
  "/family-law/child-support": "/es/derecho-de-familia/manutencion-de-los-hijos",
  "/family-law/common-law-marriages": "/es/derecho-de-familia/matrimonios-de-hecho",
  "/family-law/contested-divorce": "/es/derecho-de-familia/divorcio-contencioso",
  "/family-law/divorce-laws": "/es/derecho-de-familia/divorcio",
  "/family-law/domestic-violence": "/es/derecho-de-familia/violencia-domestica",
  "/family-law/grandparents-stepparent-adoptions": "/es/derecho-de-familia/abuelo-padrastro-adoptivo",
  "/family-law/high-asset-divorce": "/es/derecho-de-familia/divorcio-con-altos-activos",
  "/family-law/legal-separation": "/es/derecho-de-familia/separacion-legal",
  "/family-law/prenuptial-postnuptial-agreements": "/es/derecho-de-familia/acuerdos-prenupciales-y-postnupciales",
  "/family-law/property-assets": "/es/derecho-de-familia/activos-inmobiliarios",
  "/family-law/restraining-orders": "/es/derecho-de-familia/ordenes-de-restriccion",
  "/family-law/same-sex-divorce": "/es/derecho-de-familia/divorcio-de-parejas-del-mismo-sexo",
  "/family-law/wills-and-trusts-dallas-lawyers": "/es/derecho-de-familia/testamentos-y-fideicomisos",
  "/locations": "/es/ubicaciones",
  "/locations/arlington": "/es/ubicaciones/arlington",
  "/locations/fort-worth": "/es/ubicaciones/fort-worth",
  "/locations/garland": "/es/ubicaciones/garland",
  "/locations/grand-prairie": "/es/ubicaciones/grand-prairie",
  "/locations/irving": "/es/ubicaciones/irving",
  "/locations/mesquite": "/es/ubicaciones/mesquite",
  "/locations/oak-cliff-bishop-arts": "/es/ubicaciones/oak-cliff-bishop-arts",
  "/locations/plano": "/es/ubicaciones/plano",
  "/post/assisted-reproduction-and-texas-family-law-legal-parentage": "/es/post/reproduccion-asistida-y-derecho-familiar-de-texas",
  "/post/common-law-marriage-in-texas-when-are-you-legally-married": "/es/post/matrimonio-informal-en-texas-cuando-esta-legalmente-casado",
  "/post/dallas-divorce-lawyer-child-custody-attorney-in-dallas": "/es/post/abogado-de-divorcios-en-dallas-derecho-familiar",
  "/post/dallas-property-division-community-vs-separate": "/es/post/division-bienes-activos-divorcio",
  "/post/estate-planning-after-a-dallas-divorce-wills-and-trusts": "/es/post/planificacion-patrimonial-despues-de-un-divorcio-en-dallas",
  "/post/how-to-file-for-child-custody-in-texas-a-step-by-step-guide": "/es/post/como-presentar-custodia-hijos-texas",
  "/post/legal-separation-vs-divorce-in-texas-what-your-options-really-are": "/es/post/separacion-legal-vs-divorcio-en-texas",
  "/post/recognizing-the-signs-understanding-the-7-indicators-of-emotional-abuse": "/es/post/7-indicadores-de-abuso-emocional",
  "/post/same-sex-divorce-in-texas-lgbtq-family-law-after-obergefell": "/es/post/divorcio-entre-personas-del-mismo-sexo-en-texas",
  "/post/stepparent-and-grandparent-adoption-in-texas": "/es/post/adopcion-de-padrastro-y-abuelos-en-texas",
  "/post/trump-child-support-law-what-dallas-parents-should-know": "/es/post/nueva-ley-manutencion-hijos-dallas",
  "/post/trump-law-child-support-taxes": "/es/post/ley-de-trump-manutencion-taxes",
  "/post/understanding-the-difference-between-restraining-orders-and-protective-orders": "/es/post/diferencia-entre-orden-de-restriccion-y-orden-de-proteccion-en-texas",
  "/privacy": "/es/privacidad",
  "/review": "/es/resena",
  "/styleguide": "/es/styleguide",
  "/terms": "/es/terminos"
};

export default ROUTE_PAIRS;
